import { useEffect, useState } from "react";
import { GetAllWfsLogRequest } from "../../../types/WfsLog/GetAllWfsLogRequest";
import { WfsLog } from "../../../types/WfsLog/WfsLog";
import { User } from "../../../types/User";
import { getUserDetails } from "../../auth/AuthProvider";
import { Roles } from "../../../constant/Roles";
import { PaginationResult } from "../../../types/PaginiationResult";
import { DateTime } from "luxon";
import { useLocation } from "react-router-dom";
import RequestHistoryFilters from "./Filters";
import RequestHistoryTable from "./Table";
import { useUserService, useWfsLogService } from "../../../hooks";

export const RequestHistory = () => {
  const isAdmin = getUserDetails()?.roles.includes(Roles.ADMINISTRATOR);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("userId");
  const userService = useUserService();
  const wfsLogService = useWfsLogService();
  const [selectedUser, setSelectedUser] = useState<User | undefined>();

  useEffect(() => {
    if (userId) {
      userService
        .get(userId)
        .then((u) => {
          setSelectedUser(u);
        })
        .catch(() => {});
    }
  }, []);

  const [filterRequest, setFilterRequest] = useState<GetAllWfsLogRequest>({
    startIndex: 0,
    count: 10,
    startTime: DateTime.now().minus({ days: 7 }).startOf("day"),
    endTime: DateTime.now(),
    userId: userId,
  });

  const [wfsLogs, setWfsLogs] = useState<PaginationResult<WfsLog>>({
    totalItems: 0,
    items: [],
  });

  const [currentPage, setCurrentPage] = useState<number>(1);

  useEffect(() => {
    wfsLogService
      .getAllWfsLogs(filterRequest)
      .then(setWfsLogs)
      .catch(() => {});
  }, [filterRequest]);

  useEffect(() => {
    setFilterRequest({
      ...filterRequest,
      startIndex: (currentPage - 1) * filterRequest.count,
    });
  }, [currentPage]);

  return (
    <>
      <RequestHistoryFilters
        isAdmin={!!isAdmin}
        filterRequest={filterRequest}
        setFilterRequest={setFilterRequest}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        setCurrentPage={setCurrentPage}
      />
      <hr className="my-4" />
      <RequestHistoryTable
        isAdmin={!!isAdmin}
        wfsLogs={wfsLogs}
        filterRequest={filterRequest}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
      />
    </>
  );
};
